import React, { useState } from "react";
import { ModuSignCancelDocument, ModuSignDocument } from "src/api/contract/modusign-types";
import { BaseButton, BaseCheckbox, BaseInput } from "src/components";

type Props = {
  onClose: () => void;
  onSubmit: (cancelDocument: ModuSignCancelDocument) => Promise<void>;
  document: ModuSignDocument;
};

const ModuSignDocumentCancel = ({ onClose, onSubmit, document }: Props) => {
  const [cancelReason, setCancelReason] = useState<ModuSignCancelDocument>({ id: document.id, message: "", accessibleByParticipant: false });

  return (
    <>
      <section className="base-abstract-modal__title">
        <h1>문서 취소</h1>
      </section>
      <section className="base-abstract-modal__contents mx30">
        <ul className="base-list">
          <li>문서를 취소하시면 복구할 수 없습니다.</li>
        </ul>
        <div className="contents-container mt20">
          <section className="contents-container__grid ">
            <div className="contents-container__grid-index">
              <p>문서명</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <BaseInput readonly value={document.title} />
              </div>
            </div>
          </section>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p className="required">취소 사유</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <BaseInput
                  placeholder="취소 사유를 입력해주세요."
                  maxLength={200}
                  value={cancelReason.message}
                  onChange={(value: string) => setCancelReason({ ...cancelReason, message: value })}
                />
              </div>
            </div>
          </section>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p>문서 접근 제한</p>
            </div>
            <div className="contents-container__grid-contents">
              <div>
                <BaseCheckbox
                  label="서명자 접근 제한 설정"
                  id="access-restriction"
                  name="access-restriction"
                  checked={cancelReason.accessibleByParticipant}
                  onChange={(value: boolean) => setCancelReason({ ...cancelReason, accessibleByParticipant: value })}
                />
              </div>
            </div>
          </section>
        </div>
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title="닫기" className="color-white" onClick={onClose} />
        <BaseButton title="문서 취소" onClick={() => onSubmit(cancelReason)} disabled={!cancelReason.message} />
      </section>
    </>
  );
};

export default ModuSignDocumentCancel;
